<div class="ui-modal">
    <div class="header flex-row space-between-center">
        {{ 'TEST_SELECTED_CAMERA_DIALOG.TITLE'|translate }}
        <span class="ui-icon-close c-p"
              mat-dialog-close></span>
    </div>

    <div class="body h-100">
            @if(!selectIsLoadingSig()) {
            <test-camera-one-level-array-table [testCamerasRowsSig]="flatCameraRowsSig()"></test-camera-one-level-array-table>
            } @else {
            <div class="loader-center-viewport">
                <div class="loader-flex">
                    <ui-preloader [color]="loaderColor.blue"></ui-preloader>
                </div>
            </div>
            }
    </div>

    <div class="footer flex-row end-center">
        <ui-button (clickAction)="close()"
                   type="primary">
            {{ 'COMMON.DONE'|translate }}
        </ui-button>
    </div>
</div>